import AccordionToggleNew from 'approot/shared/accordion/accordion-toggle-new';
import { CheckableSingle } from 'approot/shared/styles/buttons/checkable-input';
import { Box } from 'approot/shared/design-system/box/box.style';
import { BoxPanel } from 'approot/shared/styles/box-panel.style';
import { Heading16 } from 'approot/shared/styles/typography.style';
import Text from 'approot/shared/styles/typography/text';
import { useRegionData } from 'approot/shared/region/region.apollo';
import { ActivityOutcomes } from '../key-activity-information/activity-outcomes.constants';
import useTeachingNotesOutcomeDisplay from './use-teaching-notes-outcome-display';
import PerformanceExpectationView from '../key-activity-information/standards/performance-expectation-view';
import ContentPointsMetadataView from '../key-activity-information/content-points/content-points-metadata-view';

type Props = {
  outcomes: ActivityOutcomes;
};

const TeachingNotesActivityOutcomes = ({ outcomes }: Props) => {
  const { isRegionAU } = useRegionData();
  const {
    availableCurriculums,
    activeOutcomes,
    activeCurriculum,
    setActiveCurriculum,
  } = useTeachingNotesOutcomeDisplay({ outcomes });

  return (
    <AccordionToggleNew
      title="Key Activity Information"
      withDividers
      displayExpanded={false}
    >
      {!isRegionAU ? (
        <PerformanceExpectationView outcomes={outcomes} />
      ) : (
        <>
          {/* Curriculum Pills (AU) */}
          <Box $marginBottom={16}>
            <CheckableSingle
              name="curriculum"
              options={availableCurriculums}
              selected={activeCurriculum}
              onSelect={setActiveCurriculum}
            />
          </Box>

          {activeOutcomes.map(outcome => (
            <BoxPanel key={outcome.outcomeId} $marginBottom={12}>
              <Heading16 as="h3" marginBottom={0}>
                Outcome
              </Heading16>
              <Text>{outcome.outcome.code}</Text>

              <ContentPointsMetadataView
                contentPoints={outcome.contentPoints}
                questionTypes={outcome.questionTypes}
                proficiencies={outcome.proficiencies}
              />
            </BoxPanel>
          ))}
        </>
      )}
    </AccordionToggleNew>
  );
};

export default TeachingNotesActivityOutcomes;
